<div #kpiContainer class="flex h-full grow flex-col">
  @if (!isLoading) {
    <!-- Error Message -->
    @if (isError) {
      <div class="p-4 text-center">
        <div class="text-base font-semibold text-gray-600">
          {{ title }}
        </div>
      </div>
      <ag1-bettabase-error
        class="flex grow items-center justify-center p-4"
        [errorName]="errorName"
        [errorMessage]="errorMessage"
      />
    } @else {
      <div class="flex h-full flex-wrap gap-4">
        <div
          class="flex min-w-[150px] flex-1 flex-col justify-center rounded-md bg-white p-4 text-center"
        >
          <div class="text-base font-semibold text-gray-600">{{ title }}</div>
          @if (subtitle) {
            <div class="mt-1 text-sm font-medium text-gray-500">
              {{ subtitle }}
            </div>
          }
          @if (description) {
            <div class="mt-2 px-2 text-xs text-gray-400">
              {{ description }}
            </div>
          }
          <div class="flex flex-grow flex-col justify-center">
            <div class="my-2 text-5xl font-bold text-steel-blue-500">
              {{ valueToDisplay }}
            </div>
            @if (trendEnabled) {
              <div class="mb-4 text-lg font-semibold text-gray-600">
                {{ periodToDisplay }}
              </div>
            }
            @if (trendEnabled) {
              <div class="text-sm text-gray-600">
                <span [ngClass]="getPercentChangeColour()">
                  {{ percentChangeToDisplay }}
                </span>
                <span>{{ previousValueToDisplay }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!-- KPI Display (Default Case) -->
  } @else {
    <div class="grid h-full w-full grow place-items-center gap-2 p-5">
      <ag1-loader />
    </div>
  }

  <!-- Loading State -->
</div>
